export const environment = {
  name: 'production',
  production: true,
  config_url: 'https://nutson-config.s3.eu-central-1.amazonaws.com/remoteadshostconfig.json',
  base_url: 'https://ads-api.cheelee.io',
  auth_url: 'https://ads-api-authgate.cheelee.io',
  data_lens_url: 'https://datalens.yandex.ru/gbnkfj06xgnm5-analitika-brand-takeover',
  app_name: 'Cheelee Ads Manager',
  app_version: '0.1.0',
  app_build: 'prod',
  firebaseConfig: {
    apiKey: 'AIzaSyCaQhkUee_JI4kOzRqnNOXhmMURJrZN6Fo',
    authDomain: 'cheelee-prod.firebaseapp.com',
    projectId: 'cheelee-prod',
    storageBucket: 'cheelee-prod.appspot.com',
    messagingSenderId: '684592764731',
    appId: '1:684592764731:web:919ac6a01b5c4d4386c91e',
    measurementId: 'G-R52PCLS1M5',
  },
  fingerprint: {
    apiKey: 'D8ZyPA0NT68r4pUtfznh',
    scriptUrlPattern: 'https://cheelee.io/qt0umbpy/3ykm4ap7?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
    endpoint: 'https://cheelee.io/qt0umbpy/n1wxl65h',
  },
  sentryDns: 'https://3d00df9f4dc008116cc27be7af67165c@sentry-prod.talala.la/44',
};
